import { render, staticRenderFns } from "./StockAdd.vue?vue&type=template&id=a6506a56&scoped=true&"
import script from "./StockAdd.vue?vue&type=script&lang=js&"
export * from "./StockAdd.vue?vue&type=script&lang=js&"
import style0 from "./StockAdd.vue?vue&type=style&index=0&id=a6506a56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6506a56",
  null
  
)

export default component.exports